import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-back-create-season',
    templateUrl: './back-create-season.component.html',
    styleUrls: ['./back-create-season.component.css'],
    standalone: false
})
export class BackCreateSeasonComponent {


  constructor(
    public createEditSeasonBackDialog: MatDialogRef<BackCreateSeasonComponent>,
  ){

  }


    cancel(): void {
      this.createEditSeasonBackDialog.close({"option": "cancel"});
    }

    back(): void {
      this.createEditSeasonBackDialog.close({"option": "back"});
}
}